/**
 * QUERY ANALYTICS (abbreviation):- QA
 */
export const QA_UPDATE_STATE = "QA_UPDATE_STATE"
export const QA_UPDATE_INTENT = "QA_UPDATE_INTENT"
export const QA_LOAD_CLUSTER_REQUESTS = "QA_LOAD_CLUSTER_REQUESTS"
